// extracted by mini-css-extract-plugin
export default {"switcher_container":"index_switcher_container__8nC0I","switcher_container1":"index_switcher_container1__+dt5I"};